import React from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import QRCode from "../../../layout/QRCode";
import ImageUpload from "../../../layout/ImageUpload";
import {newsletterLayoutTypes} from "../../../data/constants";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useImages} from "../../../contexts/images";

const QRcodeA4 = ({id, zoom}) => {
  const {layoutOption, type} = useSetting();
  const {titles, subtitles, links} = useEdits();
  const {uploadImages} = useImages();

  const isNewsletter = newsletterLayoutTypes.includes(type.value);
  const newsletterClass = isNewsletter ? "newsletter" : "";
  const templateClass = cn("template", `layout-${layoutOption}`, newsletterClass);

  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;
  const link = links[id] || links.main;
  const hasCustomQR1 = Boolean(uploadImages?.["custom-qr-1"]);
  const Slot1 = hasCustomQR1 ? (
    <ImageUpload id={"custom-qr-1"} transformKey={`${id}-custom-qr-1`} />
  ) : (
    <QRCode value={link} />
  );

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <div className="content">
            <div className="print-area">
              <div className="print-area__border" aria-hidden="true" />
              <div className="title" data-node-id="227:5">
                <Textarea id={id} text={title} />
              </div>
              <div className="qr-code" data-node-id="227:6">{Slot1}</div>
              <h3 className="subtitle" data-node-id="227:8">
                <Textarea id={id} lines="1" text={subtitle} />
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QRcodeA4;


